var React = require('react');

function Shield (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"28","cy":"28","r":"28","fill":"#5668F1","key":0}),React.createElement("path",{"d":"M38.5 18.2412V28.2012C38.5 31.1608 37.5067 33.8558 35.4766 36.3154C33.4978 38.7128 31.0147 40.2567 28 40.9707C24.9853 40.2567 22.5022 38.7128 20.5234 36.3154C18.4933 33.8558 17.5 31.1608 17.5 28.2012V18.2412L28 15.0449L38.5 18.2412Z","stroke":"#EBECF7","strokeWidth":"2","key":1})]);
}

Shield.defaultProps = {"width":"56","height":"56","viewBox":"0 0 56 56","fill":"none"};

module.exports = Shield;

Shield.default = Shield;
